import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const campusClassesList = createAsyncThunk(
  'school/campus-class-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}campus-class/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const campusClassStore = createAsyncThunk(
  'school/campus-class-store',
  async (campusClassData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}campus-class/store`, campusClassData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const campusClassEdit = createAsyncThunk(
  'school/campus-class-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}campus-class/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const campusClassSwitchStatus = createAsyncThunk(
  'school/campus-class-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}campus-class/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolSubjectsList = createAsyncThunk(
  'school/subject-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-subject/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolSubjectStore = createAsyncThunk(
  'school/subject-store',
  async (subjectData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-subject/store`, subjectData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolSubjectEdit = createAsyncThunk(
  'school/subject-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-subject/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolSubjectSwitchStatus = createAsyncThunk(
  'school/subject-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-subject/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolBooksList = createAsyncThunk(
  'school/book-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-book/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolBookStore = createAsyncThunk(
  'school/book-store',
  async (subjectData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-book/store`, subjectData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolBookEdit = createAsyncThunk('school/book-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-book/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const schoolBookSwitchStatus = createAsyncThunk(
  'school/book-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-book/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classBooksList = createAsyncThunk(
  'school/class-book-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-book/class-book-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const getBooks = createAsyncThunk('school/get-books', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-book/get-books`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const getClassBooks = createAsyncThunk('school/get-class-books', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-book/get-class-books`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const classBookStore = createAsyncThunk(
  'school/class-book-store',
  async (classBookData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-book/class-book-store`, classBookData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classBookEdit = createAsyncThunk(
  'school/class-book-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-book/class-book-edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classBookDelete = createAsyncThunk(
  'school/class-book-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-book/class-book-delete/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolUniformsList = createAsyncThunk(
  'school/uniforms-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolUniformStore = createAsyncThunk(
  'school/uniform-store',
  async (uniformData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-uniform/store`, uniformData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolUniformEdit = createAsyncThunk(
  'school/uniform-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolUniformSwitchStatus = createAsyncThunk(
  'school/uniform-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classUniformsList = createAsyncThunk(
  'school/class-uniform-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/class-uniform-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const getUniforms = createAsyncThunk('school/get-uniforms', async (_, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-uniform/get-uniforms`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

export const getClassUniforms = createAsyncThunk(
  'school/get-class-uniforms',
  async (_, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/get-class-uniforms`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classUniformStore = createAsyncThunk(
  'school/class-uniform-store',
  async (classUniformData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-uniform/class-uniform-store`, classUniformData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classUniformEdit = createAsyncThunk(
  'school/class-uniform-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/class-uniform-edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classUniformDelete = createAsyncThunk(
  'school/class-uniform-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-uniform/class-uniform-delete/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolTransportsList = createAsyncThunk(
  'school/transport-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-transport/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolTransportUpdate = createAsyncThunk(
  'school/transport-update',
  async (transportData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-transport/update`, transportData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolTransportEdit = createAsyncThunk(
  'school/transport-edit',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-transport/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolAcademicToolsList = createAsyncThunk(
  'school-academic-tools-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-academic-tools/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolAcademicToolsStore = createAsyncThunk(
  'school-academic-tools-store',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-academic-tools/store`, data)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolAcademicToolsEdit = createAsyncThunk(
  'school-academic-tools-edit',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-academic-tools/edit/${id}`)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const schoolAcademicToolsUpdate = createAsyncThunk(
  'school-academic-tools-update',
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-academic-tools/update`, data)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const getAdmissionFee = createAsyncThunk('get-admission-fee', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${api}admission-fee/get-admission-fee`)
    return response.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data)
  }
})

type SchoolState = {
  errors: any
}

const initialState: SchoolState = {
  errors: '',
}

export const schoolSlice = createSlice({
  name: 'school',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(campusClassStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(schoolSubjectStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(schoolBookStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(classBookStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(schoolUniformStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(classUniformStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(schoolTransportUpdate.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = schoolSlice.actions
export default schoolSlice.reducer
